import { useState } from 'react';
import cx from 'classnames';
import SVG from 'react-inlinesvg';
import { ICellRendererParams } from 'ag-grid-community';
import minusSvg from 'assets/icons/minus.svg';
import plusSvg from 'assets/icons/plus.svg';
import tableGroupLine from 'assets/icons/table-group-line.svg';

const INDENTATION = {
  BASE_CONTAINER_INDENT: 8,
  NESTED_CONTAINER_INCREMENT: 36,
  GROUP_LABEL_INDENT: 12,
  BASE_LABEL_INDENT: 24,
  NESTED_LABEL_INCREMENT: 4,
} as const;

const RowGroupRenderer: React.FC<ICellRendererParams> = (params) => {
  const { api, node, value } = params;
  const [isRowExpanded, setIsRowExpanded] = useState(node.expanded);

  const label = node.group ? node.key : value;
  const isNested = node.level > 0;

  const toggleExpandCollapseRow = (): void => {
    api.setRowNodeExpanded(node, !isRowExpanded);
    setIsRowExpanded(!isRowExpanded);
  };

  const getContainerMarginLeft = (): number => {
    if (node.level === 0) return 0;
    if (node.level === 1) return INDENTATION.BASE_CONTAINER_INDENT;
    return INDENTATION.BASE_CONTAINER_INDENT + (node.level - 1) * INDENTATION.NESTED_CONTAINER_INCREMENT;
  };

  const getLabelMarginLeft = (): number => {
    if (node.group) return INDENTATION.GROUP_LABEL_INDENT;
    if (node.level === 0) return 0;
    if (node.level === 1) return INDENTATION.BASE_LABEL_INDENT;
    return INDENTATION.BASE_LABEL_INDENT + (node.level - 1) * INDENTATION.NESTED_LABEL_INCREMENT;
  };

  return (
    <div
      className="flex items-center"
      style={{ marginLeft: `${getContainerMarginLeft()}px` }}
      data-test-id="row-group-renderer"
    >
      {isNested && <SVG src={tableGroupLine} className="absolute -top-6" />}
      {node.group && (
        <button
          className={cx('bg-neutral-100 p-0.5 rounded-full', {
            'ml-6': isNested,
          })}
          onClick={toggleExpandCollapseRow}
          type="button"
        >
          <SVG className="w-4 h-4 text-secondary" src={isRowExpanded ? minusSvg : plusSvg} />
        </button>
      )}
      <div
        className={cx('truncate', {
          'sub-header-base': !node.group,
          'body-base': node.group,
        })}
        style={{ marginLeft: `${getLabelMarginLeft()}px` }}
      >
        {label || '-'}
      </div>
    </div>
  );
};

export default RowGroupRenderer;
